export default __webpack_public_path__ + "static/media/h_2.44fe9b93.png";